import {
  FETCH_ADMINS_REQUEST,
  FETCH_ADMINS_SUCCESS,
  FETCH_ADMINS_FAILURE,
  ADD_ADMIN_SUCCESS,
  ADD_ADMIN_FAILURE,
  UPDATE_ADMIN_SUCCESS,
  UPDATE_ADMIN_FAILURE,
  DELETE_ADMIN_SUCCESS,
  DELETE_ADMIN_FAILURE,
  TOGGLE_LOCK_ADMIN_SUCCESS,
  TOGGLE_BALANCE_CHECK_ADMIN_SUCCESS
} from '../actions/adminActions';
import { PATCH_ADMIN_BALANCE_AFTER_TRANSFER } from '../actions/transferBalancePatchActions';

const initialState = {
  admins: [],
  loading: false,
  error: null
};

const adminReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ADMINS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case FETCH_ADMINS_SUCCESS:
      return {
        ...state,
        loading: false,
        admins: Array.isArray(action.payload) ? action.payload.filter(Boolean) : [],
        error: null
      };
    case FETCH_ADMINS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    case ADD_ADMIN_SUCCESS:
      if (!action.payload) return state;
      return {
        ...state,
        admins: [...state.admins, action.payload],
        error: null
      };
    case ADD_ADMIN_FAILURE:
      return state;
    case UPDATE_ADMIN_SUCCESS:
      if (!action.payload?._id) return state;
      return {
        ...state,
        admins: state.admins.map(admin => 
          admin._id === action.payload._id ? action.payload : admin
        ),
        error: null
      };
    case UPDATE_ADMIN_FAILURE:
      return state;
    case DELETE_ADMIN_SUCCESS:
      return {
        ...state,
        admins: state.admins.filter(admin => admin._id !== action.payload),
        error: null
      };
    case DELETE_ADMIN_FAILURE:
      return {
        ...state,
        error: action.payload
      };
    case TOGGLE_LOCK_ADMIN_SUCCESS:
      return {
        ...state,
        admins: state.admins.map((admin) =>
          admin._id === action.payload?._id
            ? { ...admin, isLocked: action.payload.isLocked, is_active: action.payload.is_active }
            : admin
        ),
      };
    case TOGGLE_BALANCE_CHECK_ADMIN_SUCCESS:
      return {
        ...state,
        admins: state.admins.map((admin) =>
          String(admin._id) === String(action.payload?._id)
            ? { ...admin, balance_check: action.payload.balance_check }
            : admin
        ),
      };
    case PATCH_ADMIN_BALANCE_AFTER_TRANSFER: {
      const { username, balance } = action.payload;
      if (username == null || balance == null) return state;
      return {
        ...state,
        admins: state.admins.map((admin) =>
          admin.username === username ? { ...admin, balance } : admin
        ),
      };
    }
    default:
      return state;
  }
};

export default adminReducer;